import { BodyLong, Content, Heading, HorizontalSpace, Link, VerticalSpace } from '@elhub/ds-components'
import { Warning } from '@elhub/ds-icons'

import TopContainer from 'components/TopContainer/TopContainer'

import { useTranslation } from 'react-i18next'
import { Link as NavLink } from 'react-router-dom'

import Feedback from '../components/Feedback'
import { IntroMessages } from '../locales/messages/intro'
import { LabelMessages } from '../locales/messages/label'

// Certain icons taken from Emojipedia.org, others from Elhub's Designsystem
const Introduction = () => {
  const { t } = useTranslation()
  return (
    <TopContainer>
      <Content style={{ maxWidth: '1200px' }}>
        <VerticalSpace size='2' />
        <Heading size='large' spacing>
          {t(IntroMessages.SECTION_TITLE as any)}
        </Heading>
        <VerticalSpace size='2' />
        <BodyLong>{t(IntroMessages.SECTION_1_PARAGRAPH_1 as any)}</BodyLong>
        <VerticalSpace size='2' />
        <Heading level='2' spacing>
          🏛️ {t(LabelMessages.APIS as any)}
        </Heading>
        <BodyLong>
          {t(IntroMessages.API_INTRO_TEXT as any)}{' '}
          <VerticalSpace />
          <ul>
            <li>
              <b>{t(IntroMessages.API_ANCHOR_TEXT_1 as any)}</b>{' '}
              {t(IntroMessages.API_PARAGRAPH_1 as any)}{' '}
              <Link as={NavLink} to='/energy-data-api'>
                {t(IntroMessages.API_ANCHOR_TEXT_1 as any)}
              </Link>{' '}
            </li>
            <li>
              <b>{t(IntroMessages.API_ANCHOR_TEXT_2 as any)}</b>{' '}
              {t(IntroMessages.API_PARAGRAPH_2 as any)}{' '}
              <Link as={NavLink} to='/data-export-api'>
                {t(IntroMessages.API_ANCHOR_TEXT_2 as any)}
              </Link>{' '}
            </li>
          </ul>
        </BodyLong>
        <VerticalSpace size='2' />
        <Heading level='3' spacing>
          ✅ {t(LabelMessages.Downloads as any)}
        </Heading>
        <BodyLong>
          <Link as={NavLink} to='/downloads'>
            {t(IntroMessages.DOWNLOAD_ANCHOR_TEXT_1 as any)}
          </Link>{' '}
          {t(IntroMessages.DOWNLOAD_PARAGRAPH_1 as any)}{' '}
          <Link as={NavLink} to='https://elhub.no/data'>
            {t(IntroMessages.DOWNLOAD_ELHUB_LINK as any)}
          </Link>{' '}
        </BodyLong>
        <VerticalSpace size='2' />
        {/* <Heading level='2' spacing>
          💻 {t('label:maskinporten')}
        </Heading>
        <BodyLong>
          <Link as={NavLink} to='/maskinporten'>
            {t('intro:maskinporten-anchor-text-1')}
          </Link>
          <HorizontalSpace size='0.5' />
          {t('intro:maskinporten-paragraph-1')}
        </BodyLong> */}
        <VerticalSpace size='2' />
        <Heading level='2' spacing>
          📒 {t(LabelMessages.TERMS_OF_USE as any)}
        </Heading>
        <BodyLong>
          {t(IntroMessages.TERMS_OF_USE_PARAGRAPH_1 as any)}{' '}
          <Link as={NavLink} to='https://creativecommons.org/licenses/by/4.0/' target='_blank'>
            {t(IntroMessages.TERMS_OF_USE_LICENCE as any)}
          </Link>
        </BodyLong>
        <BodyLong>{t(IntroMessages.TERMS_OF_USE_PARAGRAPH_2 as any)}</BodyLong>
        <VerticalSpace size='2' />
        <Heading level='2' spacing>
          ℹ️ {t(IntroMessages.SECTION_2_TITLE as any)}
        </Heading>
        <BodyLong>
          <ul>
            <li>{t(IntroMessages.SECTION_2_LI_1 as any)}</li>
            <li>{t(IntroMessages.SECTION_2_LI_2 as any)}</li>
            <li>
              <b>{t(IntroMessages.SECTION_2_LI_3 as any)}</b>
            </li>
            <li>{t(IntroMessages.SECTION_2_LI_4 as any)}</li>
            <li>{t(IntroMessages.SECTION_2_LI_5 as any)}</li>
          </ul>
        </BodyLong>
        <VerticalSpace size='2' />
        <Heading level='2' spacing>
          <Warning style={{ height: '20px', width: '20px', color: 'red', margin: '0 8px 5px 0' }} />
          {t(IntroMessages.RESTRICTED_TITLE as any)}
        </Heading>
        <BodyLong>
          {t(IntroMessages.RESTRICTED_ANCHOR_TEXT as any)}
          <HorizontalSpace size='0.5' />
          <Link as={NavLink} to='/data-export-api'>
            {t(IntroMessages.RESTRICTED_LINK as any)}
          </Link>
        </BodyLong>
        <VerticalSpace size='2' />
        <Heading level='2' spacing>
          🐞 {t(IntroMessages.KNOWN_ISSUES_TITLE as any)}
        </Heading>
        <Link variant='secondary' href={t(IntroMessages.KNOWN_ISSUES_LINK as any)}>
          {t(IntroMessages.KNOWN_ISSUES_LINK as any)}
        </Link>
        <VerticalSpace size='2' />
        <Feedback location='Introduction page' />
        <VerticalSpace size='2' />
        <Heading level='2' spacing>
          📧 {t(IntroMessages.CONTACT_TITLE as any)}
        </Heading>
        <Link variant='secondary' href={'mailto:' + t(IntroMessages.CONTACT_EMAIL as any)}>
          {t(IntroMessages.CONTACT_EMAIL as any)}
        </Link>
        <VerticalSpace size='2' />
      </Content>
    </TopContainer>
  )
}

export default Introduction
